// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9ca87fc3","453":"11da5fe0","455":"f39e4656","977":"e98fbc91"}[chunkId] + ".chunk.js";
};